import { request } from '@/utils'

export default {
  async find({ category, page, limit }) {
    return request({
      path: '/information',
      query: {
        category,
        limit,
        offset: (page - 1) * limit
      }
    })
  },

  async findOne({ path, id }) {
    return request({
      path: `/${path}/${id}`,
    })
  },

  async delete(query) {
    return request({
      method: 'DELETE',
      path: '/information',
      query
    })
  },

  async add(data) {
    return request({
      method: 'POST',
      path: '/information',
      data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/dynamic.js